'use es6';

import createFakeUndoRedoUpdatesMiddleware from 'ContentEditorUI/redux/middleware/createFakeUndoRedoUpdatesMiddleware';
import { UPDATE_POST_CONTENT_MODEL_TITLE, UPDATE_TITLE_FROM_INLINE, UPDATE_POST_BODY, ADDED_MODULES_TO_POST_BODY } from 'ContentEditorUI/redux/actions/actionTypes';
import { updateTitleFromUndoRedo, updatePostBodyFromUndoRedo } from '../redux/actions/postContentModelActions';
import { getPostTitleFromFakeTitleModule, getPostBodyFromFakePostBodyModule, getContentModelTitle, getContentModelPostBody } from '../redux/selectors/postContentModelSelectors';

// The postContentSettings and fake modules representing title and blog post generally stay in sync while editing,
// but when undo / redo happens only the module store is changed. These settings here make it so on any undo / redo
// the new value _after_ the revert in the fake module is taken and an action that only the postContentModelReducer
// listens for will be fired to make sure it also gets the newly reverted value.

// Try to use the value from the undoable fake module, but if we undo back
// to an initial state where there is no fake module yet, fall back to the
// initial values from the content model
const getMostCurrentTitleValue = state => {
  const titleFromFakeModule = getPostTitleFromFakeTitleModule(state);
  return titleFromFakeModule === null ? getContentModelTitle(state) : titleFromFakeModule;
};
const getMostCurrentPostBodyValue = state => {
  const postBodyFromFakeModule = getPostBodyFromFakePostBodyModule(state);
  return postBodyFromFakeModule === null ? getContentModelPostBody(state) : postBodyFromFakeModule;
};
export default createFakeUndoRedoUpdatesMiddleware({
  name: {
    get: getMostCurrentTitleValue,
    set: updateTitleFromUndoRedo,
    allowlistedActionTypes: {
      [UPDATE_TITLE_FROM_INLINE]: UPDATE_TITLE_FROM_INLINE,
      [UPDATE_POST_CONTENT_MODEL_TITLE]: UPDATE_POST_CONTENT_MODEL_TITLE
    }
  },
  post_body: {
    get: getMostCurrentPostBodyValue,
    set: updatePostBodyFromUndoRedo,
    allowlistedActionTypes: {
      [UPDATE_POST_BODY]: UPDATE_POST_BODY,
      [ADDED_MODULES_TO_POST_BODY]: ADDED_MODULES_TO_POST_BODY
    }
  }
});